import { render, staticRenderFns } from "./AdminAudit.vue?vue&type=template&id=245adc86&scoped=true"
import script from "./AdminAudit.vue?vue&type=script&lang=js"
export * from "./AdminAudit.vue?vue&type=script&lang=js"
import style0 from "./AdminAudit.vue?vue&type=style&index=0&id=245adc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245adc86",
  null
  
)

export default component.exports